import React from 'react';
import moment from 'moment';
import ConnectedCommunities from './connectedCommunities/ConnectedCommunities';
import ApplicatingCommunities from './applicatingCommunities/ApplicatingCommunities';
// Cup icon
import Cup from '../../../../assets/icons/ReactSvg/Cup';

import '../Landing.css';

import { Grid, Card, CardContent, Divider } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import headersSection from '../headersStyle';
import testimonialsSection from '../testimonialsStyle';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid black',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  ...testimonialsSection,
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
  card: {
    border: '1px solid #283f71',
    paddingTop: '24px',
    position: 'relative',
  },
  icon: {
    width: '61px',
    height: '61px',
    backgroundColor: '#f2f5f9',
    borderRadius: '50%',
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  centered: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  number: {
    color: '#051031',
    fontWeight: 'bold',
    fontSize: '68px',
    fontFamily: 'Arial',
  },
  text: {
    color: '#051031',
    margin: 0,
  },
}));

const Spreading = (props) => {
  const { classes } = props;
  const expClasses = useStyles();

  const { communitiesConnected, communitiesReady, communitiesInprogress, statError } = props;

  // setting date
  let currentDate = moment().format('DD.MM.YYYY');

  return (
    // {/* SPREADING */}
    <div>
      <div className={classes.spreading} id="spreading">
        <div className={classes.container}>
          <Grid container spacing={3} justify="center">
            <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
              <h2 className={classes.title}>А що там у сусідів?</h2>
              <h5 className={classes.description}>
                Перегляньте, хто вже успішно приєднався та користується ПК «ІІС «Соціальна громада»?
              </h5>
            </Grid>
            {!statError && (
              <Grid item xs={12} sm={12} md={8}>
                <Card>
                  <CardContent className={expClasses.card}>
                    <Grid container justify="center">
                      {/* successfully */}
                      <Grid item xs={6} sm={4}>
                        <div className={expClasses.centered}>
                          <span className={expClasses.number}>{communitiesConnected}</span>
                        </div>
                      </Grid>
                      <Grid item xs={6} sm={8}>
                        <div className={expClasses.centered}>
                          <p className={expClasses.text}>
                            {'стільки ТГ успішно приєднались'} {'до ПК «ІІС «Соціальна громада»'}
                          </p>
                        </div>
                      </Grid>
                      {/* Готові до підключення */}
                      <Grid item xs={6} sm={4}>
                        <div className={expClasses.centered}>
                          <span className={expClasses.number}>{communitiesReady}</span>
                        </div>
                      </Grid>
                      <Grid item xs={6} sm={8}>
                        <div className={expClasses.centered}>
                          <p className={expClasses.text}>
                            {'стільки ТГ готові до підключення'} {'до ПК «ІІС «Соціальна громада»'}
                          </p>
                        </div>
                      </Grid>
                      {/* Заявки в роботі для підключення */}
                      <Grid item xs={6} sm={4}>
                        <div className={expClasses.centered}>
                          <span className={expClasses.number}>{communitiesInprogress}</span>
                        </div>
                      </Grid>
                      <Grid item xs={6} sm={8}>
                        <div className={expClasses.centered}>
                          <p className={expClasses.text}>
                            {'стільки заявок ТГ в роботі для підключення'} {'до ПК «ІІС «Соціальна громада»'}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className={expClasses.centered}>
                          <p className={expClasses.text}>Дані за станом на {currentDate}</p>
                        </div>
                      </Grid>
                    </Grid>
                    <div className={expClasses.icon}>
                      <Cup />
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={8}>
              <div>
                <ConnectedCommunities />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={8}>
              <div>
                <ApplicatingCommunities />
              </div>
            </Grid>

            {/* <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <iframe
                    src="https://public.tableau.com/views/-_15795619275770/-?:embed=y&amp;:showVizHome=no&amp;:host_url=https%3A%2F%2Fpublic.tableau.com%2F&amp;:tabs=no&amp;:toolbar=yes&amp;:animate_transition=yes&amp;:display_static_image=no&amp;:display_spinner=no&amp;:display_overlay=yes&amp;:display_count=yes&amp;:loadOrderID=0"
                    title="map-widget"
                    style={{ width: '100%', height: '850px', border: '0' }}
                  >
                    <p>Your browser does not support iframes.</p>
                  </iframe>
                </CardContent>
              </Card>
            </Grid> */}
          </Grid>
        </div>
      </div>

      <Divider />
    </div>
  );
};

export default withStyles(headersSection)(Spreading);
